var render = function render(){var _vm=this,_c=_vm._self._c;return _c('t-table',{attrs:{"local-data":_vm.payees,"columns":_vm.columns,"options":_vm.options}})
}
var staticRenderFns = []

export { render, staticRenderFns }